import React, { useEffect, useState, useContext } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  Row,
  Col,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Toast,
  Collapse,
} from "reactstrap";
import FalconCardHeader from "../common/FalconCardHeader";
import WizardError from "../auth/register/WizardError";
import classNames from "classnames";
import ButtonIcon from "../common/ButtonIcon";
import { useForm, Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import FullPagination from "../common/pagination/FullPagination";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams } from "react-router";
import SelectPropertyListItem from "../common/SelectPropertyListItem";
import { PreloadState } from "../UI/preloading/PreloadState";
import { fetchCondominiumPeriod, fetchCreatePeriod } from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { useCallback } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CreatePeriodForm from "../period/CreatePeriodForm";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const CreatePaymentFundForm = ({
  handleSubmitData,
  handler,
  properties,
  setRedirect,
  setRedirectUrl,
  aliquot,
}) => {
  const moduleBase = useModuleBase();

  const { id } = useParams();
  const history = useHistory();
  const { baseCurrency } = useContext(CurrencyContext);
  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting },
    setValue,
    watch,
    setError,
    clearErrors,
    control,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
  });

  const [collapseOne, collapseOneOpen] = useState(false);
  const [openFrecuente, setOpenFrecuente] = useState(false);
  const [openCredito, setOpencredito] = useState(false);
  const [collapseCredito, collapseCreditoOpen] = useState(false);
  const {
    condominium: { selectedCondominium },
  } = useSelector((state) => state);

  console.log(errors);

  const handleSubmitDataPeriod = async (values) => {
    try {
      const response = await fetchCreatePeriod(selectedCondominium, values);

      if (response.code === SUCCESS_RESPONSE.OK) {
        history.push({
          pathname: `/dashboard/finance/${id}/reserve-funds/create`,
        });
        /*         setRedirectUrl(`/dashboard/${moduleBase}/${id}/common-costs/create`);
        setRedirect(true); */
        Toast.fire({
          type: "success",
          title: "Se ha creado el periodo satisfactoriamente.",
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const [periods, setPeriods] = useState([]);
  const fetchApiPeriods = useCallback(async () => {
    try {
      const response = await fetchCondominiumPeriod(selectedCondominium);
      setPeriods(
        response.data && response.data.length >= 0 ? response.data : []
      );
      console.log(response);
    } catch (error) {
      setPeriods([]);
    }
  }, []);
  useEffect(() => {
    fetchApiPeriods();
  }, [fetchApiPeriods]);

  return (
    <>
      <Card
        data-testid="form"
        tag={Form}
        className="bg-light"
        onSubmit={handleSubmit(handleSubmitData)}
      >
        <PreloadState
          loading={isSubmitting}
          message="Emitiendo cobro para fondo de reserva..."
        >
          <FalconCardHeader title="Emitir cobro para fondo de reserva" light={false} />
          <CardBody>
            <Row form>
              <Col sm tag={FormGroup}>
                <Label for="name">Nombre</Label>
                <Input
                  id="name"
                  name="name"
                  innerRef={register("name", {
                    required: "Nombre del gasto es requerido.",
                    pattern: {
                      value: /^[a-zA-Z0-9 %]+$/i,
                      message: "Solo se aceptan alfanúmericos.",
                    },
                  })}
                  onChange={(event) => {
                    register("name");
                    setValue("name", event.target.value);
                  }}
                  /*    value={watch("name")} */
                  autoComplete="off"
                  placeholder="Nombre del fondo"
                  className={classNames({
                    "border-danger": errors.name?.message,
                  })}
                />
                {errors.name && (
                  <WizardError
                    error={errors.name.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                )}
              </Col>
            </Row>
            <FormGroup>
              <Label for="description">Descripción</Label>
              <Input
                autoComplete="off"
                name="description"
                onChange={(event) => {
                  register("description");
                  setValue("description", event.target.value);
                }}
                /*   value={watch("description")} */
                innerRef={register("description", {
                  required: "La descripción es obligatoria.",
                  minLength: {
                    value: 10,
                    message:
                      "La descripción debe tener al menos 10 carácteres.",
                  },
                })}
                /*  onChange={(values) => {
                  setValue("description", values.value);
                }} */
                type={"textarea"}
                className={`${errors.description?.message ? "border danger" : ""
                  } form-control`}
                placeholder="Descripción del fondo"
              />
              <WizardError
                error={errors.description?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </FormGroup>
            <Row form>
              <Col sm tag={FormGroup}>
                <Label for="acronym">Balance</Label>
                <NumberFormat
                  name="balance"
                  fixedDecimalScale={true}
                  prefix={`${baseCurrency.symbol} `}
                  decimalScale={2}
                  {...register("balance", {
                    required: { value: true, message: "Ingresar el monto" },
                  })}
                  onValueChange={(values) => {
                    setValue("balance", Number(values.value));
                  }}
                  className={`${errors.balance?.message ? "border danger" : ""
                    } form-control`}
                  placeholder="Monto"
                  thousandSeparator={true}
                  renderText={(value, props) => <div {...props}>{value}</div>}
                />
                <WizardError
                  error={errors.balance?.message}
                  className="fs--1 font-weight-normal d-block"
                />
              </Col>
              <Col sm tag={FormGroup}>
                <Label for="is_cash" className="ml-1 mt-1">
                  Tipos de pago
                </Label>
                <Input
                  name="is_cash"
                  type="select"
                  className="position-relative m-0 ml-2 p-0"
                  innerRef={register("is_cash")}
                  onChange={(event) => {
                    setValue("is_cash", Boolean(event.target.value));
                  }}
                /*                   value={watch("type_payment_supplier")} */
                >
                  <option value={true}>Efectivo</option>
                  <option value={false}>Banco</option>
                </Input>
              </Col>
            </Row>
            <Label for="period_id">Seleccionar período</Label>
            <Row form className="mb-3">
              <Col sm tag={FormGroup}>
                <Controller
                  name="period_id"
                  control={control}
                  rules={{ required: { value: true, message: "Selecciona un período" } }}
                  render={({ onChange, value, ref, onBlur }) => (
                    <Input
                      type="select"
                      onChange={(e) => onChange(Number(e.target.value))}
                      onBlur={onBlur}
                      value={value}
                      innerRef={ref}
                      className={`${errors.period_id?.message ? "border-danger" : ""} form-select, overflow-auto`}
                    >
                      {periods.length > 0 ? (
                        <>
                          <option value="Selecciona">
                            ---
                          </option>
                          {periods.map((period) => (
                            <option
                              defaultValue="1"
                              value={period.id}
                              key={period.id}
                            >
                              {period.name} - {period.start_at} - {period.end_at}
                            </option>
                          ))}
                        </>
                      ) : (
                        <option disabled value="">
                          No hay periodos registrados
                        </option>
                      )}
                    </Input>
                  )}
                />
              </Col>

              <Col sm tag={FormGroup}>
                <Button
                  color="primary"
                  block
                  onClick={() => {
                    setOpencredito(false);
                    collapseCreditoOpen(!collapseCredito);
                  }}
                >
                  Registrar un nuevo periodo
                </Button>
              </Col>
              <Collapse isOpen={openCredito}>
                <Modal
                  isOpen={collapseCredito}
                  className="modal-lg"
                  data-testid="modal"
                >
                  <ModalBody>
                    <CreatePeriodForm
                      condominiumId={selectedCondominium}
                      handleSubmitData={handleSubmitDataPeriod}
                      setRedirect={setRedirect}
                      setRedirectUrl={setRedirectUrl}
                      handleClose={() => collapseCreditoOpen(false)}
                    />
                  </ModalBody>
                </Modal>
              </Collapse>
            </Row>
          </CardBody>
          <CardFooter className={classNames("px-md-6 bg-light d-flex")}>
            <ButtonIcon
              color="falcon-default"
              className="ml-auto px-5 mr-2"
              icon={faUndo}
              onClick={() => {
                setRedirectUrl(`/dashboard/finance/${id}/reserve-funds`);
                setRedirect(true);
              }}
              iconAlign="right"
              transform="down-1 shrink-4"
            >
              Volver
            </ButtonIcon>
            <ButtonIcon
              color="primary"
              className="px-5"
              onClick={() => collapseOneOpen(!collapseOne)}
              icon="save"
              iconAlign="right"
              transform="down-1 shrink-4"
            >
              Guardar
            </ButtonIcon>
          </CardFooter>
          <Modal isOpen={collapseOne} data-testid="modal">
            <ModalHeader>Confirmación</ModalHeader>
            <ModalBody>
              <p className="mb-0 font-weight-bold fs--1">
                ¿Está seguro de que ingresó todos los datos correctamente? Esta
                información no puede ser cambiada posteriormente.
              </p>
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => collapseOneOpen(!collapseOne)}>
                Cancelar
              </Button>
              <Button
                data-testid="submit-button"
                color="primary"
                type="submit"
                /*                 disabled={Object.keys(errors).length > 0} */
                onClick={handleSubmit(handleSubmitData)}
              >
                Sí, registrar
              </Button>
            </ModalFooter>
          </Modal>
        </PreloadState>
      </Card>
    </>
  );
};

export default withRedirect(CreatePaymentFundForm);
